import { Container, Image } from "react-bootstrap";
import "./OurHistory.css";
import React from "react";
import logo from "../../../../Asset/blog/logo-web.png";

const OurHistory = ({ historyRef, visibleSection }) => {
  return (
    <>
      <section className="our-history-section" ref={historyRef}>
        <Container>
          <div className="top-text-ourhistory">
            <h2>
              OUR <span>HISTORY</span>
            </h2>
          </div>
          <Container className="inner-cont">
            <div className="row about-scroll-row">
              <div className="col-4">
                <div
                  className="left-scroll-side"
                  style={{
                    background: [
                      "var(--primary-gradiant)",
                      "var(--primary-mid-gradiant)",
                      "var(--primary-color)",
                    ][visibleSection],
                  }}
                >
                  <div className="heading-element">
                    <h3>Codeffi at a GLANCE</h3>
                  </div>
                  <div className="circle-scroll">
                    <svg
                      class="svg-shadow"
                      xmlns="http://www.w3.org/2000/svg"
                      width="366"
                      height="366"
                      viewBox="0 0 366 366"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_1_304)">
                        <path
                          d="M183 366C284.068 366 366 284.068 366 183C366 81.9319 284.068 0 183 0C81.9319 0 0 81.9319 0 183C0 284.068 81.9319 366 183 366Z"
                          fill="white"
                        />
                        <path
                          class="gauge-path"
                          d="M182.996 326.13C201.938 326.306 220.73 322.749 238.297 315.662C255.865 308.576 271.864 298.098 285.383 284.828C298.901 271.558 309.673 255.756 317.085 238.323C324.496 220.89 328.401 202.167 328.576 183.225C328.752 164.283 325.195 145.492 318.108 127.924C311.022 110.356 300.545 94.3567 287.275 80.8383C274.005 67.3199 258.202 56.5476 240.769 49.1365C223.336 41.7253 204.614 37.8204 185.671 37.6447"
                          stroke="#C1C1C1"
                          strokeWidth="4"
                        ></path>
                        <path
                          class="gauge-path path-2"
                          d="M182.996 326.13C201.938 326.306 220.73 322.749 238.297 315.662C255.865 308.576 271.864 298.098 285.383 284.828C298.901 271.558 309.673 255.756 317.085 238.323C324.496 220.89 328.401 202.167 328.576 183.225C328.752 164.283 325.195 145.492 318.108 127.924C311.022 110.356 300.545 94.3567 287.275 80.8383C274.005 67.3199 258.202 56.5476 240.769 49.1365C223.336 41.7253 204.614 37.8204 185.671 37.6447"
                          stroke="black"
                          strokeWidth="4"
                          style={{
                            strokeDashoffset:
                              visibleSection === 0
                                ? "-450px"
                                : visibleSection === 1
                                ? "-220px"
                                : visibleSection === 2
                                ? "0px"
                                : "",
                          }}
                        ></path>
                        <circle
                          class="circle_1"
                          cx="183"
                          cy="37.6442"
                          r="7.32"
                          fill="var(--primary-color)"
                          style={{ fill: "var(--primary-color)" }}
                        ></circle>
                        <circle
                          class="circle_2"
                          cx="329.406"
                          cy="183"
                          r="7.32"
                          fill="#C1C1C1"
                          style={{
                            fill:
                              visibleSection === 0
                                ? "rgb(193, 193, 193)"
                                : visibleSection === 1
                                ? "var(--primary-color)"
                                : visibleSection === 2
                                ? "var(--primary-color)"
                                : "",
                          }}
                        ></circle>
                        <circle
                          class="circle_3"
                          cx="183"
                          cy="326.261"
                          r="7.32"
                          fill="#C1C1C1"
                          style={{
                            fill:
                              visibleSection === 0
                                ? "rgb(193, 193, 193)"
                                : visibleSection === 1
                                ? "rgb(193, 193, 193)"
                                : visibleSection === 2
                                ? "var(--primary-color)"
                                : "",
                          }}
                        ></circle>
                        <g clip-path="url(#clip1_1_304)">
                          <mask
                            id="mask0_1_304"
                            style={{ maskType: "luminance" }}
                            maskUnits="userSpaceOnUse"
                            x="253"
                            y="128"
                            width="18"
                            height="20"
                          >
                            <path
                              d="M253.231 128.639H270.998V147.619H253.231V128.639Z"
                              fill="white"
                            />
                          </mask>
                          <g mask="url(#mask0_1_304)">
                            <mask
                              id="mask1_1_304"
                              style={{ maskType: "luminance" }}
                              maskUnits="userSpaceOnUse"
                              x="253"
                              y="129"
                              width="18"
                              height="18"
                            >
                              <path
                                d="M264.226 129.58C263.316 129.351 262.393 129.277 261.456 129.344C260.519 129.419 259.616 129.634 258.747 129.998C257.884 130.362 257.095 130.854 256.381 131.468C255.666 132.088 255.073 132.802 254.588 133.611C254.453 133.921 254.284 134.191 254.143 134.467C253.907 134.946 253.739 135.444 253.638 135.97C253.496 136.53 253.415 137.096 253.381 137.675C253.355 138.255 253.381 138.828 253.469 139.401C253.55 139.974 253.685 140.533 253.88 141.072C254.076 141.618 254.318 142.144 254.615 142.636C254.905 143.135 255.248 143.593 255.633 144.025C256.017 144.456 256.441 144.84 256.9 145.191C257.365 145.534 257.85 145.831 258.369 146.08C258.888 146.323 259.427 146.518 259.987 146.66C260.883 146.882 261.786 146.956 262.71 146.889C263.626 146.822 264.516 146.613 265.372 146.269C266.221 145.919 267.003 145.453 267.718 144.86C268.425 144.267 269.032 143.58 269.524 142.805L270.171 141.504H270.205C270.373 141.093 270.515 140.675 270.609 140.237C270.744 139.677 270.825 139.111 270.852 138.531C270.879 137.958 270.845 137.385 270.757 136.813C270.67 136.24 270.528 135.687 270.333 135.141C270.137 134.602 269.895 134.083 269.598 133.591C269.302 133.092 268.958 132.634 268.574 132.209C268.19 131.778 267.765 131.394 267.307 131.05C266.848 130.706 266.356 130.409 265.837 130.16C265.325 129.918 264.786 129.722 264.226 129.58Z"
                                fill="white"
                              />
                            </mask>
                            <g mask="url(#mask1_1_304)">
                              <path
                                d="M254.075 125.769L249.862 146.225L270.157 150.451L274.363 130.001L254.075 125.769Z"
                                fill="url(#paint0_linear_1_304)"
                              />
                            </g>
                          </g>
                          <mask
                            id="mask2_1_304"
                            style={{ maskType: "luminance" }}
                            maskUnits="userSpaceOnUse"
                            x="251"
                            y="218"
                            width="20"
                            height="20"
                          >
                            <path
                              d="M251.507 218.36H270.487V237.341H251.507V218.36Z"
                              fill="white"
                            />
                          </mask>
                          <g mask="url(#mask2_1_304)">
                            <mask
                              id="mask3_1_304"
                              style={{ maskType: "luminance" }}
                              maskUnits="userSpaceOnUse"
                              x="252"
                              y="219"
                              width="19"
                              height="18"
                            >
                              <path
                                d="M263.615 219.402C262.698 219.173 261.775 219.099 260.838 219.173C259.901 219.24 258.998 219.456 258.135 219.82C257.266 220.184 256.477 220.676 255.763 221.289C255.055 221.91 254.455 222.624 253.97 223.433L253.498 224.289C253.289 224.774 253.12 225.28 252.986 225.792C252.73 226.81 252.656 227.841 252.763 228.886C252.878 229.937 253.161 230.928 253.626 231.871C254.091 232.815 254.698 233.644 255.459 234.365C256.221 235.093 257.077 235.66 258.041 236.071C259.005 236.482 260.002 236.718 261.047 236.765C262.092 236.819 263.109 236.684 264.107 236.367C265.105 236.051 266.015 235.572 266.843 234.931C267.666 234.284 268.36 233.516 268.913 232.626C269.149 232.215 269.351 231.77 269.553 231.359H269.587C269.755 230.948 269.863 230.544 269.998 230.099C270.133 229.533 270.214 228.967 270.241 228.387C270.268 227.807 270.241 227.234 270.153 226.661C270.065 226.088 269.924 225.529 269.735 224.983C269.54 224.444 269.29 223.918 268.994 223.426C268.697 222.927 268.36 222.469 267.969 222.038C267.585 221.606 267.16 221.222 266.702 220.878C266.237 220.535 265.752 220.238 265.226 219.988C264.707 219.739 264.168 219.544 263.615 219.402Z"
                                fill="white"
                              />
                            </mask>
                            <g mask="url(#mask3_1_304)">
                              <path
                                d="M253.377 215.582L249.158 236.092L269.547 240.338L273.766 219.828L253.377 215.582Z"
                                fill="#2771E0"
                              />
                            </g>
                          </g>
                          <mask
                            id="mask4_1_304"
                            style={{ maskType: "luminance" }}
                            maskUnits="userSpaceOnUse"
                            x="95"
                            y="88"
                            width="152"
                            height="187"
                          >
                            <path
                              d="M95 88.4H246.33V274.752H95V88.4Z"
                              fill="white"
                            />
                          </mask>
                          <g mask="url(#mask4_1_304)">
                            <mask
                              id="mask5_1_304"
                              style={{ maskType: "luminance" }}
                              maskUnits="userSpaceOnUse"
                              x="95"
                              y="88"
                              width="151"
                              height="187"
                            >
                              <path
                                d="M238.087 241.476C236.867 241.22 235.647 241.227 234.427 241.496C233.207 241.766 232.095 242.271 231.091 243.013C227.687 245.453 224.101 247.589 220.34 249.423C216.579 251.256 212.69 252.759 208.673 253.932C204.662 255.111 200.578 255.94 196.426 256.419C192.274 256.904 188.108 257.039 183.93 256.816L182.743 256.749C179.319 256.513 175.922 256.048 172.559 255.347C132.057 246.909 106.047 207.034 114.432 166.303C122.817 125.579 162.442 99.3664 202.91 107.812C212.825 109.861 221.944 113.777 230.275 119.56H230.309C230.807 120.025 231.347 120.429 231.94 120.76C232.735 121.184 233.571 121.494 234.454 121.683C235.431 121.878 236.415 121.905 237.406 121.771C238.397 121.629 239.341 121.333 240.23 120.874C241.12 120.423 241.915 119.83 242.603 119.101C243.297 118.374 243.856 117.558 244.274 116.641C244.685 115.731 244.948 114.774 245.043 113.77C245.137 112.766 245.07 111.782 244.834 110.798C244.605 109.82 244.214 108.91 243.675 108.061C243.135 107.219 242.468 106.484 241.686 105.864H241.652L241.073 105.453L240.938 105.352C230.491 97.9509 219.019 92.9565 206.509 90.348C156.463 79.9277 107.476 112.287 97.0826 162.683C86.696 213.08 118.88 262.35 168.96 272.804C175.167 274.105 181.442 274.752 187.785 274.752C194.134 274.752 200.409 274.099 206.617 272.798C212.825 271.497 218.837 269.569 224.654 267.021C230.47 264.473 235.964 261.359 241.14 257.673L241.309 257.565L241.686 257.261L241.855 257.16C243.486 255.812 244.53 254.107 244.975 252.031C245.097 251.458 245.157 250.879 245.157 250.292C245.164 249.706 245.11 249.126 245.002 248.547C244.888 247.973 244.726 247.414 244.503 246.868C244.288 246.329 244.018 245.81 243.695 245.318C243.378 244.833 243.014 244.374 242.603 243.956C242.198 243.538 241.753 243.168 241.268 242.837C240.79 242.507 240.277 242.231 239.745 242.002C239.206 241.766 238.653 241.597 238.087 241.476Z"
                                fill="white"
                              />
                            </mask>
                            <g mask="url(#mask5_1_304)">
                              <path
                                d="M101.175 58.3935L58.233 267.089L238.991 304.76L281.932 96.0643L101.175 58.3935Z"
                                fill="url(#paint1_linear_1_304)"
                              />
                            </g>
                          </g>
                          <mask
                            id="mask6_1_304"
                            style={{ maskType: "luminance" }}
                            maskUnits="userSpaceOnUse"
                            x="129"
                            y="123"
                            width="103"
                            height="115"
                          >
                            <path
                              d="M231.661 123.462H129.857V237.344H231.661V123.462Z"
                              fill="white"
                            />
                          </mask>
                          <g mask="url(#mask6_1_304)">
                            <mask
                              id="mask7_1_304"
                              style={{ maskType: "luminance" }}
                              maskUnits="userSpaceOnUse"
                              x="131"
                              y="124"
                              width="101"
                              height="113"
                            >
                              <path
                                d="M202.173 234.742C197.543 236.043 192.818 236.73 188.012 236.804C183.199 236.872 178.461 236.319 173.79 235.153L171.822 234.607H171.789C170.757 234.31 169.733 233.98 168.722 233.623C167.711 233.266 166.713 232.881 165.722 232.464C164.731 232.052 163.754 231.608 162.79 231.136C161.82 230.664 160.869 230.165 159.933 229.639C158.996 229.114 158.079 228.554 157.176 227.975C156.266 227.395 155.383 226.795 154.507 226.162C153.637 225.528 152.788 224.874 151.952 224.193C151.123 223.513 150.307 222.812 149.519 222.084C148.724 221.356 147.955 220.608 147.2 219.832C146.452 219.064 145.724 218.269 145.023 217.453C144.315 216.638 143.635 215.809 142.981 214.953C142.321 214.103 141.687 213.227 141.08 212.337C140.474 211.448 139.894 210.545 139.335 209.621C138.782 208.698 138.249 207.754 137.751 206.804C137.252 205.847 136.773 204.883 136.328 203.899C135.884 202.915 135.466 201.924 135.075 200.92C134.684 199.915 134.32 198.898 133.99 197.873C133.659 196.842 133.356 195.81 133.08 194.766C132.81 193.721 132.567 192.67 132.352 191.611C132.143 190.553 131.961 189.488 131.806 188.423C131.651 187.352 131.529 186.28 131.442 185.201C131.348 184.13 131.287 183.051 131.26 181.973C131.233 180.894 131.233 179.816 131.267 178.738C131.294 177.659 131.361 176.581 131.455 175.502C131.543 174.431 131.671 173.359 131.826 172.287C131.981 171.222 132.163 170.158 132.379 169.099C132.594 168.041 132.844 166.99 133.113 165.945C133.39 164.907 133.693 163.869 134.03 162.844C134.367 161.82 134.731 160.802 135.122 159.798C135.513 158.794 135.931 157.803 136.382 156.819C136.834 155.841 137.306 154.871 137.811 153.92C138.317 152.97 138.849 152.033 139.409 151.11C139.961 150.186 140.548 149.283 141.155 148.393C141.768 147.504 142.401 146.634 143.062 145.785C143.716 144.929 144.403 144.1 145.111 143.284C145.812 142.476 146.547 141.68 147.295 140.912C148.05 140.144 148.818 139.395 149.613 138.667C150.409 137.946 151.224 137.239 152.06 136.564C152.896 135.884 153.745 135.23 154.614 134.603C155.491 133.976 156.38 133.37 157.284 132.79C158.194 132.217 159.11 131.664 160.054 131.139C160.991 130.613 161.941 130.121 162.905 129.649C163.876 129.177 164.853 128.739 165.844 128.328C166.834 127.91 167.839 127.533 168.85 127.175C169.861 126.818 170.885 126.495 171.916 126.198C172.948 125.902 173.986 125.639 175.037 125.403C176.082 125.167 177.133 124.965 178.192 124.789C179.25 124.614 180.315 124.466 181.38 124.358C182.445 124.244 183.516 124.156 184.588 124.109C185.66 124.055 186.731 124.035 187.803 124.048C188.875 124.055 189.946 124.095 191.018 124.169C192.09 124.244 193.155 124.345 194.22 124.479C195.285 124.614 196.343 124.783 197.401 124.978C198.453 125.174 199.504 125.396 200.542 125.652C201.587 125.908 202.625 126.191 203.649 126.508C204.674 126.825 205.691 127.169 206.696 127.546C207.7 127.917 208.697 128.321 209.682 128.753C210.659 129.191 211.63 129.649 212.587 130.134C213.544 130.627 214.487 131.139 215.417 131.685C216.341 132.224 217.251 132.797 218.147 133.39C219.044 133.983 219.92 134.603 220.783 135.25C221.639 135.897 222.481 136.564 223.303 137.259C224.119 137.953 224.921 138.674 225.703 139.416C226.485 140.157 227.24 140.919 227.981 141.7L229.437 143.345C229.633 143.588 229.801 143.851 229.949 144.127C230.516 145.125 230.893 146.19 231.082 147.322C231.264 148.454 231.25 149.58 231.035 150.705C230.819 151.831 230.414 152.889 229.821 153.866C229.228 154.844 228.48 155.693 227.59 156.401C226.694 157.109 225.703 157.641 224.618 157.992C223.533 158.349 222.42 158.497 221.281 158.443C220.142 158.396 219.05 158.146 217.999 157.702C216.947 157.25 216.011 156.637 215.182 155.848L214.299 154.857C212.775 153.226 211.117 151.743 209.331 150.409C207.545 149.074 205.651 147.915 203.656 146.924C201.661 145.933 199.598 145.125 197.455 144.511C195.318 143.891 193.141 143.473 190.931 143.251C188.713 143.028 186.495 143.008 184.278 143.184C182.06 143.365 179.877 143.736 177.726 144.316C175.576 144.889 173.494 145.65 171.478 146.601C169.463 147.551 167.549 148.676 165.736 149.971C163.923 151.265 162.238 152.721 160.687 154.318C159.13 155.922 157.728 157.648 156.488 159.508C155.241 161.362 154.17 163.309 153.273 165.359C152.377 167.408 151.669 169.524 151.15 171.701C150.631 173.878 150.307 176.082 150.186 178.32C150.058 180.558 150.132 182.782 150.409 185.006C150.678 187.23 151.15 189.407 151.811 191.544C152.478 193.681 153.327 195.743 154.358 197.725C155.39 199.713 156.589 201.587 157.951 203.353C159.319 205.119 160.829 206.75 162.487 208.246C164.145 209.736 165.924 211.07 167.819 212.236C169.719 213.409 171.701 214.4 173.777 215.216C175.846 216.024 177.976 216.644 180.16 217.076C182.344 217.5 184.548 217.73 186.772 217.756C188.996 217.783 191.207 217.608 193.404 217.238C195.595 216.867 197.738 216.301 199.834 215.539C204.465 213.874 208.597 211.367 212.223 208.024C212.256 208.024 212.256 208.024 212.256 207.99L213.038 207.269C213.463 206.905 213.914 206.575 214.4 206.278C215.377 205.705 216.422 205.314 217.534 205.112C218.646 204.916 219.765 204.916 220.877 205.119C221.996 205.321 223.041 205.712 224.011 206.292C224.989 206.871 225.831 207.599 226.546 208.482C227.26 209.372 227.799 210.349 228.163 211.428C228.527 212.506 228.696 213.618 228.669 214.757C228.635 215.896 228.413 216.995 227.988 218.053C227.563 219.111 226.977 220.062 226.215 220.904C225.892 221.302 225.528 221.652 225.123 221.962H225.09C218.478 228.082 210.841 232.342 202.173 234.742Z"
                                fill="white"
                              />
                            </mask>
                            <g mask="url(#mask7_1_304)">
                              <path
                                d="M84.9735 148.579L209.505 82.499L277.52 212.328L152.988 278.402L84.9735 148.579Z"
                                fill="url(#paint2_linear_1_304)"
                              />
                            </g>
                          </g>
                          <mask
                            id="mask8_1_304"
                            style={{ maskType: "luminance" }}
                            maskUnits="userSpaceOnUse"
                            x="164"
                            y="163"
                            width="75"
                            height="35"
                          >
                            <path
                              d="M238.567 163.145H164.372V197.655H238.567V163.145Z"
                              fill="white"
                            />
                          </mask>
                          <g mask="url(#mask8_1_304)">
                            <mask
                              id="mask9_1_304"
                              style={{ maskType: "luminance" }}
                              maskUnits="userSpaceOnUse"
                              x="165"
                              y="163"
                              width="73"
                              height="34"
                            >
                              <path
                                d="M165.332 178.122C165.453 177.199 165.655 176.282 165.932 175.392C166.208 174.496 166.558 173.633 166.976 172.798C167.401 171.962 167.886 171.173 168.446 170.418C168.998 169.663 169.612 168.969 170.286 168.322C170.96 167.675 171.681 167.089 172.449 166.563C173.218 166.037 174.026 165.579 174.876 165.195C175.725 164.804 176.594 164.494 177.498 164.251C178.394 164.015 179.311 163.853 180.234 163.773C181.164 163.685 182.088 163.678 183.018 163.752C183.948 163.827 184.858 163.981 185.761 164.211C186.664 164.44 187.541 164.743 188.39 165.12C189.246 165.498 190.055 165.943 190.836 166.462C191.612 166.981 192.339 167.554 193.02 168.194C193.694 168.834 194.314 169.529 194.881 170.277C195.447 171.018 195.939 171.807 196.37 172.636C196.802 173.465 197.159 174.328 197.448 175.217C200.704 177.064 205.186 178.19 210.181 178.19C214.454 178.19 218.397 177.34 221.484 175.939C222.273 174.577 223.344 173.519 224.713 172.757C225.38 172.366 226.094 172.07 226.849 171.874C227.294 171.766 227.752 171.699 228.211 171.665C229.471 171.544 230.698 171.692 231.897 172.11C233.097 172.528 234.149 173.175 235.065 174.058H235.099L235.746 174.773C236.09 175.163 236.386 175.581 236.629 176.04C236.912 176.545 237.148 177.071 237.323 177.617C237.505 178.169 237.633 178.729 237.708 179.309C237.775 179.882 237.795 180.461 237.748 181.034C237.708 181.614 237.613 182.18 237.458 182.739C237.303 183.299 237.101 183.838 236.838 184.357C236.582 184.869 236.279 185.361 235.921 185.82C235.571 186.271 235.173 186.689 234.742 187.073C234.304 187.451 233.832 187.781 233.333 188.064C231.743 188.974 230.03 189.345 228.211 189.163C227.746 189.115 227.294 189.035 226.849 188.92C225.434 188.563 224.193 187.889 223.115 186.905L222.131 185.847C222.131 185.826 222.117 185.813 222.097 185.813L221.484 184.889C218.397 183.454 214.454 182.598 210.181 182.598C205.186 182.598 200.704 183.73 197.448 185.604C197.118 186.575 196.707 187.511 196.208 188.408C195.71 189.298 195.137 190.14 194.483 190.929C193.829 191.717 193.108 192.438 192.326 193.092C191.537 193.746 190.702 194.319 189.812 194.818C188.922 195.317 187.992 195.728 187.028 196.058C186.058 196.381 185.074 196.617 184.062 196.759C183.052 196.901 182.041 196.948 181.023 196.907C180.005 196.86 179.001 196.718 178.003 196.489C177.012 196.253 176.049 195.937 175.118 195.525C174.182 195.114 173.292 194.615 172.449 194.043C171.607 193.463 170.825 192.816 170.097 192.095C169.376 191.374 168.722 190.591 168.142 189.749C167.563 188.907 167.064 188.017 166.646 187.08C166.228 186.143 165.898 185.179 165.655 184.182C165.419 183.184 165.271 182.173 165.217 181.149C165.157 180.124 165.197 179.106 165.332 178.089V178.122Z"
                                fill="white"
                              />
                            </mask>
                            <g mask="url(#mask9_1_304)">
                              <path
                                d="M234.803 149.169L244.354 195.582L168.149 211.469L158.592 165.049L234.803 149.169Z"
                                fill="url(#paint3_linear_1_304)"
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                      <defs>
                        <linearGradient
                          id="paint0_linear_1_304"
                          x1="251.972"
                          y1="135.985"
                          x2="272.272"
                          y2="140.163"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#2771E0" />
                          <stop offset="0.0625" stop-color="#2771E0" />
                          <stop offset="0.09375" stop-color="#2771E0" />
                          <stop offset="0.109375" stop-color="#2870DF" />
                          <stop offset="0.125" stop-color="#286FDE" />
                          <stop offset="0.140625" stop-color="#296EDE" />
                          <stop offset="0.15625" stop-color="#296DDD" />
                          <stop offset="0.171875" stop-color="#2A6DDD" />
                          <stop offset="0.1875" stop-color="#2A6CDC" />
                          <stop offset="0.203125" stop-color="#2B6BDB" />
                          <stop offset="0.21875" stop-color="#2B6ADB" />
                          <stop offset="0.234375" stop-color="#2C6ADA" />
                          <stop offset="0.25" stop-color="#2C69DA" />
                          <stop offset="0.257812" stop-color="#2D68D9" />
                          <stop offset="0.265625" stop-color="#2D68D9" />
                          <stop offset="0.273438" stop-color="#2E67D8" />
                          <stop offset="0.28125" stop-color="#2E66D8" />
                          <stop offset="0.289062" stop-color="#2E66D7" />
                          <stop offset="0.296875" stop-color="#2F65D7" />
                          <stop offset="0.304688" stop-color="#2F64D6" />
                          <stop offset="0.3125" stop-color="#2F64D6" />
                          <stop offset="0.320313" stop-color="#3063D6" />
                          <stop offset="0.328125" stop-color="#3062D5" />
                          <stop offset="0.335938" stop-color="#3162D5" />
                          <stop offset="0.34375" stop-color="#3161D4" />
                          <stop offset="0.351562" stop-color="#3160D4" />
                          <stop offset="0.359375" stop-color="#3260D3" />
                          <stop offset="0.367188" stop-color="#325FD3" />
                          <stop offset="0.375" stop-color="#335ED3" />
                          <stop offset="0.382813" stop-color="#335ED2" />
                          <stop offset="0.390625" stop-color="#335DD2" />
                          <stop offset="0.398438" stop-color="#345CD1" />
                          <stop offset="0.40625" stop-color="#345CD1" />
                          <stop offset="0.414062" stop-color="#355BD0" />
                          <stop offset="0.421875" stop-color="#355AD0" />
                          <stop offset="0.429688" stop-color="#355ACF" />
                          <stop offset="0.4375" stop-color="#3659CF" />
                          <stop offset="0.445313" stop-color="#3658CF" />
                          <stop offset="0.453125" stop-color="#3657CE" />
                          <stop offset="0.460938" stop-color="#3757CE" />
                          <stop offset="0.46875" stop-color="#3756CD" />
                          <stop offset="0.476563" stop-color="#3855CD" />
                          <stop offset="0.484375" stop-color="#3855CC" />
                          <stop offset="0.492188" stop-color="#3854CC" />
                          <stop offset="0.5" stop-color="#3953CC" />
                          <stop offset="0.507812" stop-color="#3953CB" />
                          <stop offset="0.515625" stop-color="#3A52CB" />
                          <stop offset="0.523438" stop-color="#3A51CA" />
                          <stop offset="0.53125" stop-color="#3A51CA" />
                          <stop offset="0.539062" stop-color="#3B50C9" />
                          <stop offset="0.546875" stop-color="#3B4FC9" />
                          <stop offset="0.554688" stop-color="#3B4FC8" />
                          <stop offset="0.5625" stop-color="#3C4EC8" />
                          <stop offset="0.570312" stop-color="#3C4DC7" />
                          <stop offset="0.578125" stop-color="#3D4CC7" />
                          <stop offset="0.585938" stop-color="#3D4CC6" />
                          <stop offset="0.59375" stop-color="#3E4BC6" />
                          <stop offset="0.601563" stop-color="#3E4AC5" />
                          <stop offset="0.609375" stop-color="#3F49C4" />
                          <stop offset="0.617188" stop-color="#3F48C4" />
                          <stop offset="0.625" stop-color="#4047C3" />
                          <stop offset="0.632812" stop-color="#4047C3" />
                          <stop offset="0.640625" stop-color="#4146C2" />
                          <stop offset="0.648438" stop-color="#4145C1" />
                          <stop offset="0.65625" stop-color="#4244C1" />
                          <stop offset="0.664062" stop-color="#4243C0" />
                          <stop offset="0.671875" stop-color="#4342C0" />
                          <stop offset="0.679688" stop-color="#4342BF" />
                          <stop offset="0.6875" stop-color="#4441BE" />
                          <stop offset="0.695313" stop-color="#4440BE" />
                          <stop offset="0.703125" stop-color="#453FBD" />
                          <stop offset="0.710938" stop-color="#453EBD" />
                          <stop offset="0.71875" stop-color="#463DBC" />
                          <stop offset="0.726563" stop-color="#463DBB" />
                          <stop offset="0.734375" stop-color="#473CBB" />
                          <stop offset="0.742188" stop-color="#473BBA" />
                          <stop offset="0.75" stop-color="#483ABA" />
                          <stop offset="0.757812" stop-color="#4839B9" />
                          <stop offset="0.765625" stop-color="#4938B8" />
                          <stop offset="0.773438" stop-color="#4938B8" />
                          <stop offset="0.78125" stop-color="#4A37B7" />
                          <stop offset="0.789063" stop-color="#4A36B7" />
                          <stop offset="0.796875" stop-color="#4B35B6" />
                          <stop offset="0.804688" stop-color="#4B34B5" />
                          <stop offset="0.8125" stop-color="#4C33B5" />
                          <stop offset="0.820313" stop-color="#4C32B4" />
                          <stop offset="0.828125" stop-color="#4D32B4" />
                          <stop offset="0.835938" stop-color="#4D31B3" />
                          <stop offset="0.84375" stop-color="#4E30B3" />
                          <stop offset="0.851562" stop-color="#4E2FB2" />
                          <stop offset="0.859375" stop-color="#4F2EB1" />
                          <stop offset="0.867187" stop-color="#4F2DB1" />
                          <stop offset="0.875" stop-color="#502DB0" />
                          <stop offset="0.882812" stop-color="#502CB0" />
                          <stop offset="0.890625" stop-color="#512BAF" />
                          <stop offset="0.898438" stop-color="#512AAE" />
                          <stop offset="0.90625" stop-color="#5229AE" />
                          <stop offset="0.914062" stop-color="#5228AD" />
                          <stop offset="0.921875" stop-color="#5328AD" />
                          <stop offset="0.9375" stop-color="#5327AC" />
                          <stop offset="1" stop-color="#5327AC" />
                        </linearGradient>
                        <linearGradient
                          id="paint1_linear_1_304"
                          x1="135.039"
                          y1="47.123"
                          x2="222.604"
                          y2="310.215"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#0091D4" />
                          <stop offset="0.125" stop-color="#0091D4" />
                          <stop offset="0.1875" stop-color="#0091D4" />
                          <stop offset="0.203125" stop-color="#0092D4" />
                          <stop offset="0.21875" stop-color="#0092D4" />
                          <stop offset="0.234375" stop-color="#0093D4" />
                          <stop offset="0.25" stop-color="#0094D3" />
                          <stop offset="0.265625" stop-color="#0094D3" />
                          <stop offset="0.28125" stop-color="#0095D3" />
                          <stop offset="0.296875" stop-color="#0096D3" />
                          <stop offset="0.3125" stop-color="#0096D3" />
                          <stop offset="0.328125" stop-color="#0097D3" />
                          <stop offset="0.334773" stop-color="#0098D3" />
                          <stop offset="0.34375" stop-color="#0098D2" />
                          <stop offset="0.359375" stop-color="#0099D2" />
                          <stop offset="0.375" stop-color="#0099D2" />
                          <stop offset="0.390625" stop-color="#009AD2" />
                          <stop offset="0.398438" stop-color="#009BD2" />
                          <stop offset="0.40625" stop-color="#009BD2" />
                          <stop offset="0.414062" stop-color="#009CD2" />
                          <stop offset="0.421875" stop-color="#009CD2" />
                          <stop offset="0.429688" stop-color="#009DD1" />
                          <stop offset="0.4375" stop-color="#009ED1" />
                          <stop offset="0.445312" stop-color="#009ED1" />
                          <stop offset="0.453125" stop-color="#009FD1" />
                          <stop offset="0.460938" stop-color="#009FD1" />
                          <stop offset="0.46875" stop-color="#00A0D1" />
                          <stop offset="0.476562" stop-color="#00A1D1" />
                          <stop offset="0.484375" stop-color="#00A1D0" />
                          <stop offset="0.492188" stop-color="#00A2D0" />
                          <stop offset="0.5" stop-color="#00A2D0" />
                          <stop offset="0.507812" stop-color="#00A3D0" />
                          <stop offset="0.515625" stop-color="#00A4D0" />
                          <stop offset="0.523438" stop-color="#00A4D0" />
                          <stop offset="0.53125" stop-color="#00A5D0" />
                          <stop offset="0.539062" stop-color="#00A5CF" />
                          <stop offset="0.546875" stop-color="#00A6CF" />
                          <stop offset="0.554688" stop-color="#00A7CF" />
                          <stop offset="0.5625" stop-color="#00A7CF" />
                          <stop offset="0.570312" stop-color="#00A8CF" />
                          <stop offset="0.578125" stop-color="#00A8CF" />
                          <stop offset="0.585938" stop-color="#00A9CF" />
                          <stop offset="0.59375" stop-color="#00AACE" />
                          <stop offset="0.601562" stop-color="#00AACE" />
                          <stop offset="0.609375" stop-color="#00ABCE" />
                          <stop offset="0.617188" stop-color="#00ABCE" />
                          <stop offset="0.625" stop-color="#00ACCE" />
                          <stop offset="0.632812" stop-color="#00ACCE" />
                          <stop offset="0.640625" stop-color="#00ADCE" />
                          <stop offset="0.648438" stop-color="#00AECD" />
                          <stop offset="0.65625" stop-color="#00AECD" />
                          <stop offset="0.664062" stop-color="#00AFCD" />
                          <stop offset="0.665227" stop-color="#00AFCD" />
                          <stop offset="0.671875" stop-color="#00B0CD" />
                          <stop offset="0.679688" stop-color="#00B0CD" />
                          <stop offset="0.6875" stop-color="#00B1CD" />
                          <stop offset="0.695312" stop-color="#00B1CD" />
                          <stop offset="0.703125" stop-color="#00B2CD" />
                          <stop offset="0.710938" stop-color="#00B2CC" />
                          <stop offset="0.71875" stop-color="#00B3CC" />
                          <stop offset="0.726562" stop-color="#00B4CC" />
                          <stop offset="0.734375" stop-color="#00B4CC" />
                          <stop offset="0.742188" stop-color="#00B5CC" />
                          <stop offset="0.75" stop-color="#00B6CC" />
                          <stop offset="0.757812" stop-color="#00B6CB" />
                          <stop offset="0.765625" stop-color="#00B7CB" />
                          <stop offset="0.773438" stop-color="#00B8CB" />
                          <stop offset="0.78125" stop-color="#00B8CB" />
                          <stop offset="0.789062" stop-color="#00B9CB" />
                          <stop offset="0.796875" stop-color="#00BACA" />
                          <stop offset="0.804688" stop-color="#00BACA" />
                          <stop offset="0.8125" stop-color="#00BBCA" />
                          <stop offset="0.820312" stop-color="#00BCCA" />
                          <stop offset="0.828125" stop-color="#00BCCA" />
                          <stop offset="0.835938" stop-color="#00BDCA" />
                          <stop offset="0.84375" stop-color="#00BEC9" />
                          <stop offset="0.851562" stop-color="#00BEC9" />
                          <stop offset="0.859375" stop-color="#00BFC9" />
                          <stop offset="0.875" stop-color="#00BFC9" />
                          <stop offset="1" stop-color="#00BFC9" />
                        </linearGradient>
                        <linearGradient
                          id="paint2_linear_1_304"
                          x1="119.275"
                          y1="219.961"
                          x2="246.473"
                          y2="146.584"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#00B6F3" />
                          <stop offset="0.0405615" stop-color="#00B6F3" />
                          <stop offset="0.125" stop-color="#00B6F3" />
                          <stop offset="0.15625" stop-color="#00B6F3" />
                          <stop offset="0.171875" stop-color="#00B6F3" />
                          <stop offset="0.1875" stop-color="#00B6F2" />
                          <stop offset="0.203125" stop-color="#00B6F1" />
                          <stop offset="0.21875" stop-color="#00B6F1" />
                          <stop offset="0.234375" stop-color="#00B6F0" />
                          <stop offset="0.25" stop-color="#00B6F0" />
                          <stop offset="0.265625" stop-color="#00B6EF" />
                          <stop offset="0.28125" stop-color="#00B6EF" />
                          <stop offset="0.296875" stop-color="#00B6EE" />
                          <stop offset="0.3125" stop-color="#00B5EE" />
                          <stop offset="0.328125" stop-color="#00B5ED" />
                          <stop offset="0.34375" stop-color="#00B5EC" />
                          <stop offset="0.359375" stop-color="#00B5EC" />
                          <stop offset="0.375" stop-color="#00B5EB" />
                          <stop offset="0.390625" stop-color="#00B5EB" />
                          <stop offset="0.40625" stop-color="#00B5EA" />
                          <stop offset="0.421875" stop-color="#00B5E9" />
                          <stop offset="0.4375" stop-color="#00B5E8" />
                          <stop offset="0.453125" stop-color="#00B5E7" />
                          <stop offset="0.46875" stop-color="#00B4E6" />
                          <stop offset="0.484375" stop-color="#00B4E5" />
                          <stop offset="0.5" stop-color="#00B4E4" />
                          <stop offset="0.515625" stop-color="#00B4E3" />
                          <stop offset="0.53125" stop-color="#00B4E2" />
                          <stop offset="0.546875" stop-color="#00B4E1" />
                          <stop offset="0.5625" stop-color="#00B4E0" />
                          <stop offset="0.578125" stop-color="#00B3DF" />
                          <stop offset="0.59375" stop-color="#00B3DE" />
                          <stop offset="0.609375" stop-color="#00B3DD" />
                          <stop offset="0.625" stop-color="#00B3DC" />
                          <stop offset="0.640625" stop-color="#00B3DB" />
                          <stop offset="0.65625" stop-color="#00B3DA" />
                          <stop offset="0.671875" stop-color="#00B2D9" />
                          <stop offset="0.6875" stop-color="#00B2D8" />
                          <stop offset="0.703125" stop-color="#00B2D7" />
                          <stop offset="0.71875" stop-color="#00B2D6" />
                          <stop offset="0.734375" stop-color="#00B2D5" />
                          <stop offset="0.75" stop-color="#00B2D4" />
                          <stop offset="0.765625" stop-color="#00B1D3" />
                          <stop offset="0.78125" stop-color="#00B1D2" />
                          <stop offset="0.796875" stop-color="#00B1D1" />
                          <stop offset="0.804688" stop-color="#00B1D1" />
                          <stop offset="0.8125" stop-color="#00B1D0" />
                          <stop offset="0.820313" stop-color="#00B1D0" />
                          <stop offset="0.828125" stop-color="#00B1CF" />
                          <stop offset="0.835938" stop-color="#00B1CF" />
                          <stop offset="0.84375" stop-color="#00B1CE" />
                          <stop offset="0.851562" stop-color="#00B1CD" />
                          <stop offset="0.859375" stop-color="#00B1CD" />
                          <stop offset="0.867188" stop-color="#00B0CC" />
                          <stop offset="0.875" stop-color="#00B0CC" />
                          <stop offset="0.882812" stop-color="#00B0CB" />
                          <stop offset="0.890625" stop-color="#00B0CB" />
                          <stop offset="0.898437" stop-color="#00B0CA" />
                          <stop offset="0.90625" stop-color="#00B0C9" />
                          <stop offset="0.9375" stop-color="#00B0C9" />
                          <stop offset="0.959438" stop-color="#00B0C9" />
                          <stop offset="1" stop-color="#00B0C9" />
                        </linearGradient>
                        <linearGradient
                          id="paint3_linear_1_304"
                          x1="247.476"
                          y1="210.746"
                          x2="171.226"
                          y2="226.437"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#2771E0" />
                          <stop offset="0.125" stop-color="#2771E0" />
                          <stop offset="0.15625" stop-color="#2771E0" />
                          <stop offset="0.171875" stop-color="#2770DF" />
                          <stop offset="0.1875" stop-color="#2870DF" />
                          <stop offset="0.203125" stop-color="#286FDE" />
                          <stop offset="0.21875" stop-color="#296EDE" />
                          <stop offset="0.234375" stop-color="#296DDD" />
                          <stop offset="0.25" stop-color="#2A6DDD" />
                          <stop offset="0.265625" stop-color="#2A6CDC" />
                          <stop offset="0.28125" stop-color="#2B6BDC" />
                          <stop offset="0.296875" stop-color="#2B6BDB" />
                          <stop offset="0.3125" stop-color="#2C6ADA" />
                          <stop offset="0.328125" stop-color="#2C69DA" />
                          <stop offset="0.34375" stop-color="#2D68D9" />
                          <stop offset="0.351562" stop-color="#2D68D9" />
                          <stop offset="0.359375" stop-color="#2D67D8" />
                          <stop offset="0.367188" stop-color="#2E67D8" />
                          <stop offset="0.375" stop-color="#2E66D8" />
                          <stop offset="0.382812" stop-color="#2E65D7" />
                          <stop offset="0.390625" stop-color="#2F65D7" />
                          <stop offset="0.398437" stop-color="#2F64D6" />
                          <stop offset="0.40625" stop-color="#2F64D6" />
                          <stop offset="0.414062" stop-color="#3063D6" />
                          <stop offset="0.421875" stop-color="#3062D5" />
                          <stop offset="0.429687" stop-color="#3162D5" />
                          <stop offset="0.4375" stop-color="#3161D4" />
                          <stop offset="0.445312" stop-color="#3161D4" />
                          <stop offset="0.453125" stop-color="#3260D4" />
                          <stop offset="0.460937" stop-color="#325FD3" />
                          <stop offset="0.46875" stop-color="#325FD3" />
                          <stop offset="0.476562" stop-color="#335ED2" />
                          <stop offset="0.484375" stop-color="#335ED2" />
                          <stop offset="0.492188" stop-color="#335DD2" />
                          <stop offset="0.5" stop-color="#345CD1" />
                          <stop offset="0.507812" stop-color="#345CD1" />
                          <stop offset="0.515625" stop-color="#345BD1" />
                          <stop offset="0.523437" stop-color="#355AD0" />
                          <stop offset="0.53125" stop-color="#355AD0" />
                          <stop offset="0.539062" stop-color="#3559CF" />
                          <stop offset="0.546875" stop-color="#3659CF" />
                          <stop offset="0.554688" stop-color="#3658CF" />
                          <stop offset="0.5625" stop-color="#3657CE" />
                          <stop offset="0.570312" stop-color="#3757CE" />
                          <stop offset="0.578125" stop-color="#3756CD" />
                          <stop offset="0.585937" stop-color="#3856CD" />
                          <stop offset="0.59375" stop-color="#3855CD" />
                          <stop offset="0.601562" stop-color="#3854CC" />
                          <stop offset="0.609375" stop-color="#3954CC" />
                          <stop offset="0.617188" stop-color="#3953CB" />
                          <stop offset="0.625" stop-color="#3953CB" />
                          <stop offset="0.632812" stop-color="#3A52CB" />
                          <stop offset="0.640625" stop-color="#3A51CA" />
                          <stop offset="0.648437" stop-color="#3A51CA" />
                          <stop offset="0.65625" stop-color="#3B50C9" />
                          <stop offset="0.664062" stop-color="#3B50C9" />
                          <stop offset="0.671875" stop-color="#3B4FC9" />
                          <stop offset="0.679687" stop-color="#3C4EC8" />
                          <stop offset="0.6875" stop-color="#3C4EC8" />
                          <stop offset="0.695312" stop-color="#3D4DC7" />
                          <stop offset="0.703125" stop-color="#3D4CC7" />
                          <stop offset="0.710937" stop-color="#3D4BC6" />
                          <stop offset="0.71875" stop-color="#3E4BC6" />
                          <stop offset="0.726562" stop-color="#3E4AC5" />
                          <stop offset="0.734375" stop-color="#3F49C4" />
                          <stop offset="0.742187" stop-color="#3F48C4" />
                          <stop offset="0.75" stop-color="#4048C3" />
                          <stop offset="0.757812" stop-color="#4047C3" />
                          <stop offset="0.765625" stop-color="#4146C2" />
                          <stop offset="0.773437" stop-color="#4145C2" />
                          <stop offset="0.78125" stop-color="#4145C1" />
                          <stop offset="0.789062" stop-color="#4244C1" />
                          <stop offset="0.796875" stop-color="#4243C0" />
                          <stop offset="0.804687" stop-color="#4342C0" />
                          <stop offset="0.8125" stop-color="#4342BF" />
                          <stop offset="0.820312" stop-color="#4441BE" />
                          <stop offset="0.828125" stop-color="#4440BE" />
                          <stop offset="0.835937" stop-color="#453FBD" />
                          <stop offset="0.84375" stop-color="#453FBD" />
                          <stop offset="0.851562" stop-color="#453EBC" />
                          <stop offset="0.859375" stop-color="#463DBC" />
                          <stop offset="0.867187" stop-color="#463CBB" />
                          <stop offset="0.875" stop-color="#473BBB" />
                          <stop offset="0.882812" stop-color="#473BBA" />
                          <stop offset="0.890625" stop-color="#483ABA" />
                          <stop offset="0.898437" stop-color="#4839B9" />
                          <stop offset="0.90625" stop-color="#4938B9" />
                          <stop offset="0.914062" stop-color="#4938B8" />
                          <stop offset="0.921875" stop-color="#4A37B7" />
                          <stop offset="0.929687" stop-color="#4A36B7" />
                          <stop offset="0.9375" stop-color="#4A35B6" />
                          <stop offset="0.945312" stop-color="#4B35B6" />
                          <stop offset="0.953125" stop-color="#4B34B5" />
                          <stop offset="0.960938" stop-color="#4C33B5" />
                          <stop offset="0.96875" stop-color="#4C32B4" />
                          <stop offset="0.976562" stop-color="#4D32B4" />
                          <stop offset="0.984375" stop-color="#4D31B3" />
                          <stop offset="0.992187" stop-color="#4E30B3" />
                          <stop offset="1" stop-color="#4E2FB2" />
                        </linearGradient>
                        <clipPath id="clip0_1_304">
                          <rect width="366" height="366" fill="white" />
                        </clipPath>
                        <clipPath id="clip1_1_304">
                          <rect
                            width="176"
                            height="187.733"
                            fill="white"
                            transform="translate(95 88.4)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div className="scroll-content">
                    <ul className="years">
                      {["2010 - 2014", "2015 - 2019", "2020 - Till Now"].map(
                        (year, index) => (
                          <li
                            key={index}
                            className={
                              visibleSection === index ? "active" : "year"
                            }
                          >
                            {year}
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-8 m-auto">
                <div className="scroll-right-content-box">
                  <div className="ul-content">
                    {[
                      [
                        "Codeffi was established in December 2010.",
                        "The company began prioritizing the development of its Team.",
                        "Successfully acquired the Largest Client in Portfolio.",
                        "The Internship Program gained recognition from various Institutions.",
                        "In 2014, the company established its main branch in Mota Varchha, Surat.",
                        "By the end of 2014, the team grew to over 10+ members.",
                      ],
                      [
                        "We shifted our attention towards Larger Clients.",
                        "Our Work has received multiple Accolades and Ratings.",
                        "Office welcomes visits from International Clients.",
                        "By the end of 2019, the team grew to over 10+ members.",
                      ],
                      [
                        "Organized Company-funded trip for Employees and Families.",
                        "Established a new branch in Mota Varachha, Surat.",
                        "Successfully registered as an LLP Company.",
                        "Working with a Skilled Team of 10+ in-house employees.",
                      ],
                    ].map((content, index) => (
                      <ul
                        key={index}
                        className={
                          visibleSection === index ? "active" : "d-none"
                        }
                      >
                        {content.map((text, i) => (
                          <li key={i}>
                            <b>{text}</b>
                          </li>
                        ))}
                      </ul>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </Container>
      </section>

      <section className="our-history-section2">
        <Container>
          <div className="top-text-ourhistory">
            <h2>
              OUR <span> HISTORY</span>
            </h2>
          </div>
          <div className="history-spacer">
            <div className="history-head">
              <div className="history-heading">
                <Image src={logo} />
                <h3>
                  Codeffi at a <b> GLANCE</b>
                </h3>
              </div>
            </div>
            <div className="history-body">
              <div className="timeline">
                <div className="year-data">
                  <div className="year-body">
                    <p>2010 - 2014</p>
                  </div>
                  <div className="year-div">
                    <ul id="u-1">
                      <li>
                        Codeffi was established in <b>December 2010 .</b>
                      </li>
                      <li>
                        The company began prioritizing the development of its
                        Team.
                      </li>
                      <li>
                        Successfully acquired the Largest Client in Portfolio.
                      </li>
                      <li>
                        The Internship Program gained recognition from various
                        Institutions.
                      </li>
                      <li>
                        In <b>2014</b> , the company established its main branch
                        in <b> Mota Varachha , Surat</b> .
                      </li>
                      <li>
                        By the end of 2014, the team grew to over <b>10+</b>
                        members.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="year-data">
                  <div className="year-body">
                    <p>2015 - 2019</p>
                  </div>
                  <div className="year-div">
                    <ul id="u-2">
                      <li>
                        We shifted our attention towards <b>Larger Clients</b> .
                      </li>
                      <li>
                        Our Work has received multiple <b>Accolades</b> and{" "}
                        <b>Ratings</b> .
                      </li>
                      <li>
                        Office welcomes visits from <b>International Clients</b>{" "}
                        .
                      </li>
                      <li>
                        By the end of <b>2019</b>, the team grew to over{" "}
                        <b> 10+</b> members.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="year-data">
                  <div className="year-body">
                    <p>2020 - Till Now</p>
                  </div>
                  <div className="year-div">
                    <ul id="u-3">
                      <li>
                        Organized <b>Company-funded trip</b> for Employees and
                        Families.
                      </li>
                      <li>
                        Established a new branch in <b>Mota Varachha , Surat</b>{" "}
                        .
                      </li>
                      <li>
                        Successfully registered as a <b> LLP Company</b> .
                      </li>
                      <li>
                        Working with a Skilled Team of <b>10+</b>
                        in-house employees.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default OurHistory;
